export const allAssetPerms = (
  perms: string | string[],
  assetType: string,
  assetSubTypes?: string[]
) => {
  const _perms = Array.isArray(perms) ? perms : [perms];

  return _perms
    .map(perm => {
      if (assetSubTypes) {
        return assetSubTypes.map(subType => `${perm}_${assetType}${subType}`);
      } else {
        return `${perm}_${assetType}`;
      }
    })
    .flat();
};

export const remoteStartAny = [
  'start_rdp_remotesession',
  'start_ssh_remotesession',
  'start_vnc_remotesession',
  'start_web_remotesession',
];

export const remoteRequestAny = [
  'create_rdp_remoterequest',
  'create_ssh_remoterequest',
  'create_vnc_remoterequest',
  'create_web_remoterequest',
];

export const remoteAny = [...remoteStartAny, ...remoteRequestAny];

const sessionsViewAny = [
  'admin_view_remotesession',
  'admin_view_remoterequest',
];

const computeAssetViewAny = ['view_computeassetwindowsagentless'];

export const allAppPerms = (perms: string | string[]) =>
  allAssetPerms(perms, 'securityapplication', allApplicationTypes);

const allApplicationTypes = [
  'trellixepo',
  'wsus',
  'veeam',
  'claroty',
  'nozomi',
  'whatsupgold',
];
export const applicationViewAny = [
  ...allAppPerms('view'),
  'view_controlapplicationcentumvp',
  'view_assetmanagementapplicationprm',
  'view_assetmanagementapplicationisae',
  'view_analyzermanagementapplicationaaims',
  'view_analyzermanagementapplicationcalsys',
  'view_virtualizationapplicationmicrosofthyperv',
];
const applicationAnySecurity = [
  'view_securityapplicationtrellixepo',
  'view_securityapplicationwsus',
  'view_securityapplicationveeam',
  'view_securityapplicationclaroty',
  'view_securityapplicationnozomi',
  'view_securityapplicationwhatsupgold',
];
const applicationAnyControl = ['view_controlapplicationcentumvp'];

const fieldAssetViewAny = ['view_fieldassetprm'];

const assetManagementApplicationViewAny = [
  'view_assetmanagementapplicationprm',
  'view_assetmanagementapplicationisae',
];
const analyzerManagementApplicationViewAny = [
  'view_analyzermanagementapplicationaaims',
  'view_analyzermanagementapplicationcalsys',
];
const virtualizationApplicationViewAny = [
  'view_virtualizationapplicationmicrosofthyperv',
];

const plcAssetViewAny = [
  'view_dcsplcassetfcs',
  'view_dcsplcassetscs',
  'view_dcsplcassetavr',
  'view_dcsplcassetbcv',
  'view_dcsplcassetwac',
  'view_dcsplcassetfcn',
];

const allNetworkTypes = ['switch', 'router', 'firewall', 'timeserver'];

const envAssetViewAny = ['view_envassetodu'];

const assetDiscoveryViewAny = ['view_assetdiscovery'];

const fieldAssetDiscoveryViewAny = ['view_fieldassetdiscovery'];

const networkAssetViewAny = allAssetPerms(
  ['view'],
  'networkasset',
  allNetworkTypes
);

export const assetsViewAny = [
  ...computeAssetViewAny,
  ...fieldAssetViewAny,
  ...plcAssetViewAny,
  ...networkAssetViewAny,
  ...envAssetViewAny,
  ...assetDiscoveryViewAny,
  ...fieldAssetDiscoveryViewAny,
];

const groupViewAny = [
  'view_group',
  'view_grouppermission',
  'view_groupobjectpermission',
];
const userViewAny = [
  'view_user',
  'view_userpermission',
  'view_userobjectpermission',
];

const userAny = ['user', 'userpermission', 'userobjectpermission'];

const groupAny = ['group', 'grouppermission', 'groupobjectpermission'];

const authViewAny = [...userViewAny, ...groupViewAny];

const activityLogAny = ['view_activitylog'];

const adminViewAny = [...sessionsViewAny, ...assetsViewAny, ...authViewAny];

const configurationViewAny = [
  'view_configuration_site',
  'view_automation',
  'view_customfield',
  'view_servicenowconfig',
  'view_worker',
];

const fileTransferAny = [
  // 'add_center_filetransfer', //upload center
  // 'view_center_filetransfer', // download center
  'add_filetransfer', //upload site
  'view_filetransfer', // download site
  'share_filetransfer', // share files
  'expire_filetransfer', // set expiration date
];
const fileTransferViewAny = [
  'add_filetransfer', //upload site
  'view_filetransfer', // download site
  'share_filetransfer', // share files
  'expire_filetransfer', // set expiration date
];
const customFieldAny = [
  'add_customfield',
  'view_customfield',
  'change_customfield',
  'delete_customfield',
];
const customFieldViewAny = ['add_customfield', 'view_customfield'];
const alertsAny = ['view_center_alert', 'change_alert'];
const alertsViewAny = ['view_center_alert'];

export const permissionSet = {
  remoteStartAny,
  remoteRequestAny,
  remoteAny,
  assetsViewAny,
  computeAssetViewAny,
  customFieldAny,
  customFieldViewAny,
  fieldAssetViewAny,
  assetManagementApplicationViewAny,
  analyzerManagementApplicationViewAny,
  virtualizationApplicationViewAny,
  plcAssetViewAny,
  networkAssetViewAny,
  envAssetViewAny,
  sessionsViewAny,
  authViewAny,
  adminViewAny,
  activityLogAny,
  applicationViewAny,
  applicationAnySecurity,
  applicationAnyControl,
  userAny,
  userViewAny,
  groupAny,
  groupViewAny,
  configurationViewAny,
  fileTransferAny,
  fileTransferViewAny,
  alertsAny,
  alertsViewAny,
};
